import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";

export default function AcceptQuoteSuccess() {
  const [searchParams] = useSearchParams();
  const session_id = searchParams.get("session_id");

  const [loading, setLoading] = useState(true);
  const [orderId, setOrderId] = useState(null);

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        const { data } = await axiosInstance.get(
          `/api/payments/quote/checkout/success?session_id=${session_id}`
        );

        if (data.success) {
          setOrderId(data.orderId);
        }
      } catch (err) {
        console.error("Payment verification failed:", err);
      }

      setLoading(false);
    };

    verifyPayment();
  }, [session_id]);

  if (loading) return <div className="p-8">Verifying payment...</div>;

  return (
    <div className="p-8 text-center">
      <h1 className="text-3xl font-bold text-green-600">Payment Successful!</h1>
      <p className="mt-4 text-lg">Thank you for your order.</p>

      {orderId && (
        <p className="mt-2 text-gray-700">
          Your order ID is: <span className="font-bold">{orderId}</span>
        </p>
      )}

      <button
        className="mt-6 px-5 py-3 bg-candy-primary text-white rounded-lg"
        onClick={() => (window.location.href = "https://candyhavenandcakes.com")}
      >
        Return to Home
      </button>
    </div>
  );
}
